import { render, staticRenderFns } from "./SetPasswordView.vue?vue&type=template&id=54d117bf&scoped=true&"
import script from "./SetPasswordView.vue?vue&type=script&lang=ts&"
export * from "./SetPasswordView.vue?vue&type=script&lang=ts&"
import style0 from "./SetPasswordView.vue?vue&type=style&index=0&id=54d117bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d117bf",
  null
  
)

export default component.exports